/**
 * SSR Window 3.0.0-alpha.4
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: May 20, 2020
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.ssrWindow = {}));
})(this, function (exports) {
  'use strict';
  /* eslint-disable no-param-reassign */

  function isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
  }

  function extend(target, src) {
    if (target === void 0) {
      target = {};
    }

    if (src === void 0) {
      src = {};
    }

    Object.keys(src).forEach(function (key) {
      if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
        extend(target[key], src[key]);
      }
    });
  }

  var ssrDocument = {
    body: {},
    addEventListener: function () {},
    removeEventListener: function () {},
    activeElement: {
      blur: function () {},
      nodeName: ''
    },
    querySelector: function () {
      return null;
    },
    querySelectorAll: function () {
      return [];
    },
    getElementById: function () {
      return null;
    },
    createEvent: function () {
      return {
        initEvent: function () {}
      };
    },
    createElement: function () {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function () {},
        getElementsByTagName: function () {
          return [];
        }
      };
    },
    createElementNS: function () {
      return {};
    },
    importNode: function () {
      return null;
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    }
  };

  function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
  }

  var ssrWindow = {
    document: ssrDocument,
    navigator: {
      userAgent: ''
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    },
    history: {
      replaceState: function () {},
      pushState: function () {},
      go: function () {},
      back: function () {}
    },
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function () {},
    removeEventListener: function () {},
    getComputedStyle: function () {
      return {
        getPropertyValue: function () {
          return '';
        }
      };
    },
    Image: function () {},
    Date: function () {},
    screen: {},
    setTimeout: function () {},
    clearTimeout: function () {},
    matchMedia: function () {
      return {};
    },
    requestAnimationFrame: function (callback) {
      if (typeof setTimeout === 'undefined') {
        callback();
        return null;
      }

      return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function (id) {
      if (typeof setTimeout === 'undefined') {
        return;
      }

      clearTimeout(id);
    }
  };

  function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
  }

  exports.extend = extend;
  exports.getDocument = getDocument;
  exports.getWindow = getWindow;
  exports.ssrDocument = ssrDocument;
  exports.ssrWindow = ssrWindow;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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